const CONFERENCIA_CUSTODIANTE_DIVERGENCIA = {
  AUSLCL: { id: 1, descricao: "Posiçao ausente localmente" },
  AUSCUST: { id: 2, descricao: "Posiçao ausente no custodiante" },
  ATVAUSLCL: { id: 4, descricao: "Ativo ausente localmente" },
  ATVAUSCUST: { id: 8, descricao: "Ativo ausente no custodiante" },
  DIVPU: { id: 16, descricao: "Divergência entre preços" },
  DIVQTD: { id: 32, descricao: "Divergência entre quantidades" },
  DIVTX: { id: 64, descricao: "Divergência entre taxas" },
};

export default CONFERENCIA_CUSTODIANTE_DIVERGENCIA;
